import BaseReducer from "./BaseReducer";

class LinkAlertReducer extends BaseReducer {
  domain = "LinkAlert";
  type = "View";

  initialState = {
    isComplianceAlerts: false,
    linkAlert: null,
    linkedAlertData: [],
    selectedAlerts: [],
    activeAccordionIndex: [0, 1],
    alertConfig: null,
  };
}

const reducer = new LinkAlertReducer();

export default reducer;
